export enum WizardPanelTypes {
    SCAN_SCAN_PROCESSING = 'ScanProcessing',
    DESTINATION_WKSGROUP = 'DestinationWorkspaceGroup',
    SCAN_SELECTOR = 'ScanSelector',
    SCAN_PROJECT_CONTENT_SELECTOR = 'ScanProjectContentSelector',
    SCAN_CLOUD_LOGIN = 'ScanCloudLogin',
    REGISTRATION_REPORT_CONFIGURATOR = 'RegReportConf',
    POINT_SELECTOR = 'PointSelector',

    LAYER_SELECTION = 'LayerSelection',
    NEW_PROJECT = 'NewProject',
    POINTCLOUD_CONFIGURATION = 'PointCloudConfiguration',
    UAV_CONFIGURATION = 'UAVConfiguration',
    OBJ_MODEL_3D_CONVERTER_CONFIGURATION = 'ObjModel3DConverterConfiguration',
    GIS_IMPORTER_CONFIGURATION = 'GisImporterConfiguration',
    UPLOAD_FILES = 'UploadFiles',
    SUMMARY = 'Summary',
}
